define('container/argResolvers/DeferredServiceArgResolver',['underscore', 'knockout', 'bluebird'], function(_, ko, Promise) {

    'use strict';

    function DeferredServiceArgResolver() {
    }

    DeferredServiceArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, 7) === 'defer:@';
    };

    DeferredServiceArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var o = ko.observable();

        _.defer(function() {
            extensionApi.container.get(argDefinition.substring(7)).then(o);
        });

        return Promise.resolve(o);
    };

    return DeferredServiceArgResolver;
});

